export default {"src":"/_next/static/media/brandsHeaderIccon.eb585a75.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};